export enum OutreachExportFormatType {
  Unknown = "unknown",
  CSV = "csv",
  Tab = "tab",
  Pipe = "pipe",
  Excel = "excel",
}

export enum OutreachDataFilterType {
  Unknown = "0",
  All = "1",
  Inactive = "2",
  Exclusions = "3",
}

export enum OutreachExportType {
  Unknown = "unknown",
  PractitionerAtLocation = "practitioner-at-location",
  Practitioner = "practitioner",
  ServiceLocation = "service-location"
}